<template>
  <div class="one-to-one-agenda-block" :class="{ 'is-completed': block.is_completed }">
    <div class="agenda-block-header">
      <div class="agenda-block-header-left">
        <el-checkbox
          :disabled="!$canAndRulesPass(meeting, $permissions.ONE_TO_ONE.AGENDA_BLOCK_MANAGE)"
          :value="block.is_completed"
          @change="toggleComplete"
        />
        <span class="agenda-block-name">{{ block.name }}</span>
        <el-tag v-if="block.recommended_duration" size="mini" type="info" style="margin-left: 8px;">
          {{ block.recommended_duration }} мин.
        </el-tag>
      </div>
      <div class="agenda-block-header-right">
        <el-button
          class="table-action-button"
          size="mini"
          type="text"
          icon="fas fa-chevron-down"
          v-if="!expanded"
          @click="expanded = true"
        />
        <el-button
          class="table-action-button"
          size="mini"
          type="text"
          icon="fas fa-chevron-up"
          v-else
          @click="expanded = false"
        />

        <el-popconfirm
          v-if="$canAndRulesPass(meeting, $permissions.ONE_TO_ONE.AGENDA_BLOCK_MANAGE)"
          confirm-button-text="Да"
          cancel-button-text="Нет"
          icon="el-icon-question"
          title="Удалить блок?"
          @confirm="$emit('delete', block)"
        >
          <el-button
            slot="reference"
            class="table-action-button"
            type="default"
            round
            size="mini"
            icon="far fa-trash-alt"
          >
          </el-button>
        </el-popconfirm>
      </div>
    </div>

    <div v-if="expanded" class="agenda-block-body">
      <div v-if="block.content" class="agenda-block-content">
        <div class="section-label">Содержание / фразы</div>
        <div class="agenda-block-content-text" v-html="block.content"></div>
      </div>


      <div class="agenda-block-section">
        <div class="section-label">Заметки</div>
        <div
          v-for="note in block.notes"
          :key="note.id"
          class="note-item"
        >
          <el-input
            v-model="note.content"
            type="textarea"
            :rows="2"
            size="small"
            @blur="saveNote(note)"
          />
          <el-button
            class="table-action-button"
            size="mini"
            type="text"
            icon="far fa-trash-alt"
            @click="deleteNote(note)"
          />
        </div>
        <el-button
          size="mini"
          type="text"
          icon="fas fa-plus"
          @click="addNote"
        >Добавить заметку</el-button>
      </div>


      <div class="agenda-block-section">
        <div class="section-label">Договорённости</div>
        <div
          v-for="agreement in block.agreements"
          :key="agreement.id"
          class="agreement-item"
        >
          <el-checkbox
            :value="agreement.is_done"
            @change="toggleAgreementDone(agreement)"
          />
          <span :class="{ 'agreement-done': agreement.is_done }">
            {{ agreement.content }}
          </span>
          <el-tag size="mini" type="warning" style="margin-left: 8px;">
            до {{ formatDate(agreement.deadline) }}
          </el-tag>
          <el-button
            class="table-action-button"
            size="mini"
            type="text"
            icon="far fa-trash-alt"
            @click="deleteAgreement(agreement)"
          />
        </div>
        <el-button
          size="mini"
          type="text"
          icon="fas fa-plus"
          @click="$emit('add-agreement', block)"
        >Добавить договорённость</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AgendaBlockItem',

  props: {
    block: { type: Object, required: true },
    meeting: { type: Object, required: true },
  },

  data() {
    return {
      expanded: true,
    };
  },

  methods: {
    toggleComplete(val) {
      if (!val) return;
      this.$api.oneToOne.agendaBlockComplete({ id: this.block.id })
        .then(() => {
          this.block.is_completed = true;
        });
    },

    addNote() {
      this.$api.oneToOne.noteCreate({
        block_id: this.block.id
      })
        .then(data => {
          if (!this.block.notes) this.$set(this.block, 'notes', []);
          this.block.notes.push(data.note);
        });
    },

    saveNote(note) {
      if (!note.content) return;
      this.$api.oneToOne.noteUpdate({ id: note.id, content: note.content });
    },

    deleteNote(note) {
      this.$api.oneToOne.noteDelete({ id: note.id })
        .then(() => {
          const idx = this.block.notes.findIndex(n => n.id === note.id);
          if (idx !== -1) this.block.notes.splice(idx, 1);
        });
    },

    toggleAgreementDone(agreement) {
      if (agreement.is_done) return;
      this.$api.oneToOne.agreementMarkDone({ id: agreement.id })
        .then(() => {
          agreement.is_done = true;
        });
    },

    deleteAgreement(agreement) {
      this.$api.oneToOne.agreementDelete({ id: agreement.id })
        .then(() => {
          const idx = this.block.agreements.findIndex(a => a.id === agreement.id);
          if (idx !== -1) this.block.agreements.splice(idx, 1);
        });
    },

    formatDate(date) {
      if (!date) return '';
      const [y, m, d] = date.split('-');
      return `${d}.${m}.${y}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.one-to-one-agenda-block {
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  margin-bottom: 12px;
  background: #fff;

  &.is-completed {
    border-color: #67c23a;
    background: #f0f9eb;
  }
}

.agenda-block-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;

  &-left {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
  }

  &-right {
    display: flex;
    align-items: center;
    gap: 4px;
  }
}

.agenda-block-name {
  font-weight: 500;
  font-size: 14px;
}

.agenda-block-body {
  padding: 0 14px 14px;
  border-top: 1px solid #ebeef5;
}

.agenda-block-content {
  margin-bottom: 12px;
  padding-top: 10px;
  &-text {
    font-size: 13px;
    color: #606266;
    white-space: pre-wrap;
  }
}

.agenda-block-section {
  margin-top: 40px;
}

.section-label {
  font-size: 12px;
  color: #909399;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}

.note-item {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  margin-bottom: 6px;
}

.agreement-item {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
  font-size: 13px;
}

.agreement-done {
  text-decoration: line-through;
  color: #909399;
}
</style>